import { validateAreaCode } from '../../utils/validateAreaCode';

// The single definition of "valid" for each on-page field, imported by both
// OnPageSelfScheduleForm (the live check that drives the checkmark badge and
// the button-disable state) and onPageSelfScheduleSchema (the Yup schema that
// gates the actual submit).
//
// They must agree, and this module is what makes that structural rather than a
// convention. The form hides the below-input Yup errors in favor of its own
// label indicator, so if a rule existed in the schema but not the live check,
// the visitor would see a green checkmark and an enabled button, and the click
// would silently do nothing.
//
// Rules match consultSchema.js, minus location/description — the on-page form
// only collects contact info.

export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const isNonEmptyValue = (value) => typeof value === 'string' && value.trim().length > 0;

export const isValidEmailValue = (value) => typeof value === 'string' && EMAIL_PATTERN.test(value);

// PhoneInput's mask (`+1\ 999-999-9999`) always bakes in the "+1 " prefix, so a
// fully-typed value is 11 digits — which is what consultSchema's min(15) on the
// masked string amounts to. The area-code test is the local-sites-only rule
// from consultSchema (rejects 555, 444, ...).
export const isValidPhoneValue = (value) => {
    if (typeof value !== 'string') return false;
    const digits = value.replace(/\D/g, '');
    return digits.length === 11 && digits.startsWith('1') && validateAreaCode(value);
};
